import React, {Fragment, useEffect, useLayoutEffect, useRef, useState} from 'react';
import styles from './RemoteFeed.module.scss';
import {useVRoomSub} from "../../../hooks/Conference/Janus/useVRoomSub";
import {JanusStatus, Publisher} from "../../../constants/Janus";
import Janus from "../../../utils/Janus/janus";
import {Spin} from "antd";
import {useTranslation} from "react-i18next";
import {LoadingOutlined} from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{fontSize: 32}} spin/>

interface RemoteFeedProps {
    janusInstance: any;
    janusStatus: JanusStatus;

    room: number;
    pvtId: number;

    publisher: Publisher;
    // id: number;
    // display: string;
    // audio: string;
    // video: string;
    talking?: boolean;
    isShareFeed?: boolean;
    JanusModule?: any;
    onCleanup?: (rfid: number) => void
    reconnect?: boolean
    reconnectDuration?: number
}

export const RemoteFeed: React.FunctionComponent<RemoteFeedProps> = ({
    janusInstance,
    janusStatus,
    room,
    pvtId,
    publisher,
    // id,
    // display,
    // audio,
    // video,
    talking= false,
    JanusModule = Janus,
    onCleanup,
    isShareFeed = false,
    reconnect,
    reconnectDuration = 3000,

                                                                     }) => {
    const { t } = useTranslation();
    const feedRef = useRef<HTMLVideoElement>(null);

    const [connecting, setConnecting] = useState<boolean>(true);

    const feed = useVRoomSub({
        janusInstance,
        janusStatus,
        JanusModule
    })

    useEffect(() => {
        if (!room || !publisher || feed.cleanup || !connecting) return;
        console.log("feed.newFeed");
        setConnecting(false);
        feed.newFeed(room, publisher.id, pvtId, publisher.display, publisher.audio, publisher.video)
    }, [room, publisher, connecting])

    useEffect(() => {
        if (!feed.error || feed.cleanup) return;
        setTimeout(() => {
            setConnecting(true)
        }, reconnectDuration)
    }, [feed.error, feed.cleanup])

    useLayoutEffect(() => {
        if (!feed.stream || !feedRef.current) return
        JanusModule.attachMediaStream(feedRef.current, feed.stream);
    }, [feed.stream, feedRef.current])

    useEffect(() => {
        if (!feed.cleanup) return;
        console.log("feed.cleanup", feed.cleanup, feed.remoteFeed, feed.remoteFeed.rfid)
        feed.remoteFeed.detach();
        onCleanup?.(publisher.id);
    }, [feed.cleanup])

    return (
        <Fragment>
            <video
                ref={feedRef}
                autoPlay
                playsInline
                className={`${styles.VideoStyle}`}
            />
            { !feed.webrtcState &&
                <div className={styles.coverSpin}>
                    <div className={styles.Loading}><Spin indicator={antIcon}/></div>
                    <div className={styles.Publishing}>{t("Connecting...")}</div>
                </div>
            }
            {
                (isShareFeed) &&
                <div className={`${styles.videoRemoteMute}`}
                     style={{
                         position: "absolute",
                         backgroundPosition: "center",
                         backgroundRepeat: "no-repeat",
                         backgroundSize: "cover",
                     }}
                >
                    <span className={`${styles.screenSharing}`}>{t("Screen sharing...")}</span>
                </div>
            }
        </Fragment>
    )
}
